"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var logMessage = function logMessage(message) {
  var background = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'red';
  var color = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'white';
  return console.log("%c".concat(message), "background: ".concat(background, "; color: ").concat(color, "; font-weight: 700; border-radius: 2px; padding: 2px 4px;"));
};

var _default = logMessage;
exports.default = _default;